import React from "react";
import {Link, LinkProps, useLocation} from "react-router-dom";
import './linkwrapper.scss';


type Props = {
    hasLink?: boolean;
    keepSearchParams?: boolean;
} & LinkProps

//TODO . linkwrapper breaks left menu in PT. Does commented .linkwrapper break somthing else?
const LinkWrapper: React.FC<Props> = React.forwardRef(({hasLink = true, className, children, ...linkProps}, ref) => {
    const location = useLocation();

    if (hasLink) {
        return (
            <Link
                // className={`linkwrapper ${className}`}
                className={className}
                {...linkProps}
                to={`${linkProps.to}${location.search}`}
                ref={ref as any}
            >
                {children}
            </Link>
        )
    }

    return (
        <div className={className}>
            {children}
        </div>
    )
})

export default LinkWrapper;